import Component from '../abstracts/Component';

export default class O2OComponent extends Component {

  get COMPONENTNAME() {
    return 'O2OComponent';
  }

  get SELECTORS() {
    return {
      carousel: '[data-carousel]'
    };
  }

  constructor(compEl) {
    super(compEl);
    this.carousel = this.$component.querySelector(this.SELECTORS.carousel);
  }

  initCarousel() {
    const options = {
      arrows: false,
      dots: true,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 768,
          settings: "unslick"
        }
      ]
    };
    $(this.carousel).slick(options);
  }

  importSlick() {
    this.moduleLoader.loadCarouselAndExecute(module => {
        this.initCarousel();
      },
      error => {
        console.error('failed to load slick', error.stack);
      }
    );
  }

  render() {
    this.log('Rendering...');
    this.importSlick();
  }
}
